// functions/home_page/home_page_holidays.js

import { fetch_all_holidays, use_add_new_holiday, use_delete_holiday, use_update_holiday } from "../../api/holidays";
import logger from "../../utils/logger";

export class HomePageHolidays {

    constructor(showAlert) {
        this.showAlert = showAlert;
    }

    // Fetch holidays by date range
    async fetchHolidays(setHolidaysData, setIsLoading, range) {
        try {
            setIsLoading(true);
            const response = await fetch_all_holidays(range);

            if (response.status === 200) {
                const holidaysData = response?.data?.data || [];
                setHolidaysData(holidaysData);
            } else {
                this.showAlert({
                    message: 'Failed to fetch holidays',
                    type: 'danger',
                    buttons: [{ label: 'Close', type: 'primary' }]
                });
            }
        } catch (error) {
            logger.error("Error fetching holidays:", error);
            this.showAlert({
                message: 'An error occurred while fetching holidays',
                type: 'danger',
                buttons: [{ label: 'Close', type: 'primary' }]
            });
        } finally {
            setIsLoading(false);
        }
    }

    // Add new holiday
    async addHoliday(holidayData, setHolidaysData, setIsLoading, refreshCallback) {
        try {
            setIsLoading(true);
            const response = await use_add_new_holiday(holidayData);

            if (response.status === 201 || response.status === 200) {
                this.showAlert({
                    message: 'Holiday added successfully',
                    type: 'success',
                    buttons: [{ label: 'Close', type: 'primary' }]
                });

                // Refresh holidays data
                if (refreshCallback) {
                    await refreshCallback();
                }
            } else {
                this.showAlert({
                    message: response?.data?.error || 'Failed to add holiday',
                    type: 'danger',
                    buttons: [{ label: 'Close', type: 'primary' }]
                });
            }
        } catch (error) {
            logger.error("Error adding holiday:", error);
            this.showAlert({
                message: 'An error occurred while adding holiday',
                type: 'danger',
                buttons: [{ label: 'Close', type: 'primary' }]
            });
        } finally {
            setIsLoading(false);
        }
    }

    // Delete holiday
    async deleteHoliday(holidayId, setHolidaysData, setIsLoading, refreshCallback) {
        try {
            setIsLoading(true);
            const response = await use_delete_holiday(holidayId);

            if (response.status === 200) {
                this.showAlert({
                    message: 'Holiday deleted successfully',
                    type: 'success',
                    buttons: [{ label: 'Close', type: 'primary' }]
                });

                // Refresh holidays data
                if (refreshCallback) {
                    await refreshCallback();
                }
            } else {
                this.showAlert({
                    message: response?.data?.error || 'Failed to delete holiday',
                    type: 'danger',
                    buttons: [{ label: 'Close', type: 'primary' }]
                });
            }
        } catch (error) {
            logger.error("Error deleting holiday:", error);
            this.showAlert({
                message: 'An error occurred while deleting holiday',
                type: 'danger',
                buttons: [{ label: 'Close', type: 'primary' }]
            });
        } finally {
            setIsLoading(false);
        }
    }

    // Update holiday
    async updateHoliday(holidayData, setHolidaysData, setIsLoading, refreshCallback) {
        try {
            setIsLoading(true);
            const response = await use_update_holiday(holidayData);

            if (response.status === 200) {
                this.showAlert({
                    message: 'Holiday updated successfully',
                    type: 'success',
                    buttons: [{ label: 'Close', type: 'primary' }]
                });

                // Refresh holidays data
                if (refreshCallback) {
                    await refreshCallback();
                }
            } else {
                this.showAlert({
                    message: response?.data?.error || 'Failed to update holiday',
                    type: 'danger',
                    buttons: [{ label: 'Close', type: 'primary' }]
                });
            }
        } catch (error) {
            logger.error("Error updating holiday:", error);
            this.showAlert({
                message: 'An error occurred while updating holiday',
                type: 'danger',
                buttons: [{ label: 'Close', type: 'primary' }]
            });
        } finally {
            setIsLoading(false);
        }
    }
}